"use strict";

/******
SCROLL
*******/
document.addEventListener("DOMContentLoaded", function () {
  var topButton = document.querySelector('.js-scroll-top');
  topButton.addEventListener('click', function () {
    var cosParameter = window.scrollY / 2,
        scrollCount = 0,
        oldTimestamp = performance.now();

    function step(newTimestamp) {
      scrollCount += Math.PI / (500 / (newTimestamp - oldTimestamp));
      if (scrollCount >= Math.PI) window.scrollTo(0, 0);
      if (window.scrollY === 0) return;
      window.scrollTo(0, Math.round(cosParameter + cosParameter * Math.cos(scrollCount)));
      oldTimestamp = newTimestamp;
      window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }, false);
  window.addEventListener('scroll', function (e) {
    var scrolled = window.scrollY,
        height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    if (scrolled > height) {
      topButton.classList.add('shown');
    } else {
      topButton.classList.remove('shown');
    }

    ;
  });
});